import * as variables from '../../variables.js';

declare global {
    interface Window {
        projects: any[];
    }
}

type ProjectObject = {
	location: string,
	latlon: string,
	title: string,
	link: string,
	status: string
};

type MapController = {
	map: google.maps.Map,
	markers: google.maps.Marker[],
	baseCenter: google.maps.LatLng,
	infoWindows: google.maps.InfoWindow[]
};

type MarkerProvider = (
	controller: MapController,
) => google.maps.Marker[];

const allMarkers: google.maps.Marker[] = [];
const itemTypes: { [index: string]: any } = {
	"COMPLETED": {
		label: 'Completed Projects',
		color: variables.color_COMPLETED,
		markers: []
	},
	"INPROGRESS": {
		label: 'In Progress Projects',
		color: variables.color_INPROGRESS,
		markers: []
	}
};
const CONUS_BOUNDS = {
	north: 49.384358,
	south: 24.396308,
	west: -124.848974,
	east: -66.885444,
};
const CONUS_CENTER = {
	lat: 37.8074615,
	lng: -96
};
let mapStyles: google.maps.MapTypeStyle[] = [
	{
		"elementType": "geometry",
		"stylers": [{ "color": "#f5f5f5" }]
	},
	{
		"elementType": "labels.icon",
		"stylers": [{ "visibility": "off" }]
	},
	{
		"elementType": "labels.text.fill",
		"stylers": [{ "color": "#616161" }]
	},
	{
		"elementType": "labels.text.stroke",
		"stylers": [{ "color": "#f5f5f5" }]
	},
	{
		"featureType": "administrative",
		"elementType": "geometry",
		"stylers": [{ "visibility": "off" }]
	},
	{
		"featureType": "administrative.country",
		"elementType": "geometry.stroke",
		"stylers": [{ "color": variables.color_DEFAULT.toString() },
		{ "visibility": "on" },
		{ "weight": 1.5 }]
	},
	{
		"featureType": "administrative.country",
		"elementType": "labels.text",
		"stylers": [{ "visibility": "off" }]
	},
	{
		"featureType": "administrative.land_parcel",
		"stylers": [{ "visibility": "off" }]
	},
	{
		"featureType": "administrative.land_parcel",
		"elementType": "labels.text.fill",
		"stylers": [{ "color": "#bdbdbd" }]
	},
	{
		"featureType": "administrative.neighborhood",
		"stylers": [{ "visibility": "off" }]
	},
	{
		"featureType": "administrative.province",
		"elementType": "geometry.stroke",
		"stylers": [{ "color": variables.color_DEFAULT.toString() },
		{ "visibility": "on" },
		{ "weight": 2.5 }]
	},
	{
		"featureType": "poi",
		"stylers": [{ "visibility": "off" }]
	},
	{
		"featureType": "poi",
		"elementType": "geometry",
		"stylers": [{ "color": "#eeeeee" }]
	},
	{
		"featureType": "poi",
		"elementType": "labels.text",
		"stylers": [{ "visibility": "off" }]
	},
	{
		"featureType": "poi",
		"elementType": "labels.text.fill",
		"stylers": [{ "color": "#757575" }]
	},
	{
		"featureType": "poi.park",
		"elementType": "geometry",
		"stylers": [{ "color": "#e5e5e5" }]
	},
	{
		"featureType": "poi.park",
		"elementType": "labels.text.fill",
		"stylers": [{ "color": "#9e9e9e" }]
	},
	{
		"featureType": "road",
		"elementType": "geometry",
		"stylers": [{ "color": "#ffffff" }]
	},
	{
		"featureType": "road",
		"elementType": "labels",
		"stylers": [{ "visibility": "off" }]
	},
	{
		"featureType": "road",
		"elementType": "labels.icon",
		"stylers": [{ "visibility": "off" }]
	},
	{
		"featureType": "road.arterial",
		"stylers": [{ "visibility": "off" }]
	},
	{
		"featureType": "road.arterial",
		"elementType": "labels.text.fill",
		"stylers": [{ "color": "#757575" }]
	},
	{
		"featureType": "road.highway",
		"elementType": "geometry",
		"stylers": [{ "color": "#dadada" }]
	},
	{
		"featureType": "road.highway",
		"elementType": "labels",
		"stylers": [{ "visibility": "off" }]
	},
	{
		"featureType": "road.highway",
		"elementType": "labels.text.fill",
		"stylers": [{ "color": "#616161" }]
	},
	{
		"featureType": "road.local",
		"stylers": [{ "visibility": "off" }]
	},
	{
		"featureType": "road.local",
		"elementType": "labels.text.fill",
		"stylers": [{ "color": "#9e9e9e" }]
	},
	{
		"featureType": "transit",
		"stylers": [{ "visibility": "off" }]
	},
	{
		"featureType": "transit.line",
		"elementType": "geometry",
		"stylers": [{ "color": "#e5e5e5" }]
	},
	{
		"featureType": "transit.station",
		"elementType": "geometry",
		"stylers": [{ "color": "#eeeeee" }]
	},
	{
		"featureType": "water",
		"elementType": "geometry",
		"stylers": [{ "color": "#c9c9c9" }]
	},
	{
		"featureType": "water",
		"elementType": "labels.text",
		"stylers": [{ "visibility": "off" }]
	},
	{
		"featureType": "water",
		"elementType": "labels.text.fill",
		"stylers": [{ "color": "#9e9e9e" }]
	}
];

let mapElement = document.getElementById('map');
let mapInfoWindows: InfoWindowManager = null;

const createPin = function(color: string){
	return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 23.294" width="18" height="23.294" fill="' +color+ '"><path d="M18 9A9 9 0 1 0 0 9c0 4.985 9 14.294 9 14.294S18 13.985 18 9ZM4.809 8.824A4.191 4.191 0 1 1 9 13.015a4.218 4.218 0 0 1-4.191-4.191Z"> </path></svg>';
}

const createLegend = function () {
	var UL = document.createElement('UL');
	UL.classList.add('mapLegend');

	for (var key in itemTypes) {
		if (key == 'DEFAULT') continue;

		let LI = document.createElement('LI');
		LI.classList.add(key);
		LI.innerHTML = createPin(itemTypes[key].color) + ' ' + itemTypes[key].label;
		UL.appendChild(LI);
	}
	mapElement.parentElement.insertBefore(UL, mapElement.nextSibling);
}

class InfoWindowManager {
	private controller: MapController;

	public buildContent(obj: ProjectObject){
		let location = (obj.location !== '') ? `<div class="location">${obj.location}</div>` : '';
		let title = (obj.title !== '') ? `<div class="title">${obj.title}</div>` : '';
		let link = (obj.link !== '') ? `<a href="${obj.link}" target="_blank">View Details</a>` : '';
		return `<div>${location}${title}${link}</div>`
	}
	public cancelClose() {
		window.clearTimeout((window as any).infoWindowTimeout);
		return this;
	};
	public close(ignoreCanBeRemoved: Boolean = true) {
		let min = 0;
		let infoWindows = this.controller.infoWindows;
		while (this.controller.infoWindows.length > min) {
			if (ignoreCanBeRemoved || (infoWindows[infoWindows.length - 1] as any).canBeRemoved) {
				infoWindows.pop().close();
			} else {
				min++;
				(infoWindows[infoWindows.length - 1] as any).canBeRemoved = true;
			}
		}
		return this;
	}
	public handleClick(marker: google.maps.MVCObject, obj: ProjectObject) {
		this.cancelClose();
		this.close();

		const infoWindow = new google.maps.InfoWindow({
			content: this.buildContent(obj),
			zIndex: 202,
		});

		infoWindow.open(this.controller.map, marker);
		(infoWindow as any).canBeRemoved = false;
		this.controller.infoWindows.push(infoWindow);
		infoWindow.addListener('closeclick', () => {
			this.close();
		});
	};

	constructor(controller: MapController) {
		this.controller = controller;
	}
}

const addMarker = (
	newMarkers: google.maps.Marker[],
	lat: any,
	lon: any,
	itemType: string = 'DEFAULT',
	obj: ProjectObject,
) => {
	let legendItem = itemTypes[itemType];
	const marker = new google.maps.Marker({
		position: new google.maps.LatLng(Number(lat), Number(lon))
		,icon: {
			url: 'data:image/svg+xml;utf8,'+createPin(encodeURIComponent(legendItem.color))
		}
	});
	marker.addListener('click', event => {
		mapInfoWindows.handleClick(marker, obj);
		event.stop();
	});
	newMarkers.push(marker);
	return marker;
};


let markerProvider: MarkerProvider = (controller) => {
	const results: ProjectObject[] = window.projects;
	//*DEBUG*/console.log(results);
	let newMarkers: google.maps.Marker[] = [];

	// add markers based on results
	for (let i = 0; i < results.length; i++) {
		const result: ProjectObject = results[i];
		if (!result.latlon){
			continue;
		}
		let latlon  = result.latlon.split(',');
		let lat  = parseFloat(latlon[0]);
		let lon  = parseFloat(latlon[1]);
		let type = result.status.toUpperCase().replace(' ','');

		let marker = addMarker(newMarkers, lat, lon, type || '', result);

		itemTypes[type].markers.push(marker);
		allMarkers.push(marker);
	}

	return newMarkers;
}

const MapInitializer = () => {
	const controller: MapController = {
		map: null,
		markers: null,
		baseCenter: null,
		infoWindows: []
	};

	let projectsData = document.querySelector(".projects");

	// googlemaps callback
	(window as any).googleMapScriptLoaded = () => {
		if (!mapElement || !projectsData) {
			return;
		}

		(mapElement.parentNode as HTMLElement).classList.add('js-setup');

		if (controller.map === null) {
			controller.map = new google.maps.Map(mapElement, {
				center: CONUS_CENTER,
				fullscreenControl: false,
				mapTypeControl: false,
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				restriction: {
					latLngBounds: CONUS_BOUNDS,
					strictBounds: false,
				},
				streetViewControl: false,
				styles: mapStyles,
				zoomControl: true,
				zoom: 1,
				maxZoom: 10
			});
		}

		controller.map.fitBounds(CONUS_BOUNDS);

		// Markers
		controller.markers = markerProvider(controller);
		if (controller.markers.length > 0) {
			var bounds = new google.maps.LatLngBounds();

			controller.markers.forEach(marker => {
				marker.setMap(controller.map);
				bounds.extend(marker.getPosition());
				controller.map.fitBounds(bounds);
			});
		}

		createLegend();
	};

	(window as any).googleMapUpdatedData = () => {
		if (!mapElement || !projectsData) {
			return;
		}

		// remove markers
		if (controller.markers.length > 0) {
			controller.markers.forEach(marker => {
				marker.setMap(null);
			});
		}

		// add new markers
		controller.markers = markerProvider(controller);

		if (controller.markers.length > 0) {
			var bounds = new google.maps.LatLngBounds();
			controller.map.fitBounds(bounds);

			controller.markers.forEach(marker => {
				marker.setMap(controller.map);
				bounds.extend(marker.getPosition());
			});
			controller.map.fitBounds(bounds);
		} else {
			controller.map.fitBounds(CONUS_BOUNDS);
		}
	};

	mapInfoWindows = new InfoWindowManager(controller);

	// listen for changes to projectData
	document.addEventListener('jsfAjaxEvent', evt=>{
		if ((evt as any).detail.fireType === 'success'){
			(window as any).googleMapUpdatedData();
		}
	});

};

export default MapInitializer;
